import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const cMCustomerCampaignApi = createApi({
  reducerPath: 'cMCustomerCampaignApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['CustomerCampaignServices'],
  endpoints: (builder) => ({
    getCustomerCampaignServices: builder.query({
      query: (params) => ({
        url: '/campaigns/customer-campaign-services/',
        method: 'GET',
        params,
      }),
      providesTags: ['CustomerCampaignServices'],
    }),
    createCustomerCampaignService: builder.mutation({
      query: ( body ) => ({
        url: `/campaigns/customer-campaign-services/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomerCampaignServices'],
    }),
    getCustomerCampaignServiceById: builder.query({
      query: (id) => ({
        url: `/campaigns/customer-campaign-services/${id}`,
        method: 'GET',
      }),
      providesTags: ['CustomerCampaignServices'],
    }),
    updateCustomerCampaignService: builder.mutation({
      query: ({ id, body }) => ({
        url: `/campaigns/customer-campaign-services/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['CustomerCampaignServices'],
    }),
    deleteCustomerCampaignService: builder.mutation({
      query: id => ({
        url: `/campaigns/customer-campaign-services/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ['CustomerCampaignServices']
    })
  }),
});

export const {
  useGetCustomerCampaignServicesQuery,
  useCreateCustomerCampaignServiceMutation,
  useGetCustomerCampaignServiceByIdQuery,
  useUpdateCustomerCampaignServiceMutation,
  useDeleteCustomerCampaignServiceMutation,
} = cMCustomerCampaignApi;